import { initializeApp } from 'firebase/app';
import { getMessaging } from 'firebase/messaging';

const FirebaseConfig = {
  apiKey: "AIzaSyA11JkcwX6yFVHXA5cb-tDj565mc0UBe-0",
  authDomain: "spka-bomba.firebaseapp.com",
  projectId: "spka-bomba",
  storageBucket: "spka-bomba.firebasestorage.app",
  messagingSenderId: "376643235648",
  appId: "1:376643235648:web:5d2e52653ab84760fd94a5",
  measurementId: "G-6R3FL10HFR"
};

const app = initializeApp(FirebaseConfig);
const messaging = getMessaging(app);

export { app, messaging };
export default FirebaseConfig

